import React, { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Col, Flex, Row, Switch, TabsProps } from 'antd';

import BasePane from '@totem/components/BasePane';
import DeviceContainerTable from '@totem/components/devices/devicesContainer/DeviceContainerTable';
import DevicesContainer, {
  containerConfiguration,
} from '@totem/components/devices/devicesContainer/DevicesContainer';
import TagsSection from '@totem/components/software/software_report/byTag/tagsSection';
import CountBadge from '@totem/components/software/software_report/countBadge';
import SoftwareContainer from '@totem/components/software/software_report/softwareContainer';
import SoftwareTable from '@totem/components/software/software_report/softwareTable';
import IBTabs from '@totem/components/ui_components/antDesignOverrides/IBTabs';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import PrimaryContentPane from '@totem/components/ui_components/page/PrimaryContentPane';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { DEVICES_ENDPOINT } from '@totem/utilities/endpoints';

const styles = {
  totals: {
    fontSize: '16px',
    marginRight: '20px',
  },
  tabContainer: {
    paddingRight: '2rem',
    paddingLeft: '2rem',
  },
  inset: {
    marginLeft: '20px',
    marginRight: '20px',
  },
};

const VendorDetailsPage = () => {
  const { id } = useParams();
  const { userProfile } = useContext(UserProfileContext);
  const vendor = id ?? '';
  const [grouped, setGrouped] = useState<boolean>(false);

  const getTabItems = () => {
    const tabItems: TabsProps['items'] = [
      {
        key: 'devices',
        label: 'Devices',
        children: (
          <InputContainer
            filterConfig={containerConfiguration}
            defaultSort={{
              field: 'device.displayName',
              direction: 'ascend',
            }}
            staticFilters={[{ field: 'vendor', values: [vendor] }]}
            componentKey={'vendor.devices'}
          >
            <DevicesContainer onRecordTotalChanged={() => {}}>
              <DeviceContainerTable />
            </DevicesContainer>
          </InputContainer>
        ),
      },
      {
        key: 'software',
        label: 'Software',
        children: (
          <SoftwareContainer
            endPoint={`${DEVICES_ENDPOINT}/software/catalog`}
            organizationId={userProfile.organization.id}
            defaultPublisher={vendor}
          >
            <div style={styles.inset}>
              <Row>
                <Col span={12} />
                <Col span={12}>
                  <Flex justify={'flex-end'} align={'center'}>
                    Group by Tag:
                    <Switch
                      style={{ marginRight: '16px', marginLeft: '8px' }}
                      onChange={setGrouped}
                      value={grouped}
                    />
                    <CountBadge />
                  </Flex>
                </Col>
              </Row>
              <br />
              {!grouped && <SoftwareTable />}
              {grouped && <TagsSection />}
            </div>
          </SoftwareContainer>
        ),
      },
    ];
    return tabItems;
  };

  return (
    <ContentLayout pageTitle={`Vendor: ${vendor}`}>
      <BasePane>
        <PrimaryContentPane>
          <IBTabs
            defaultActiveKey="devices"
            style={styles.tabContainer}
            items={getTabItems()}
          />
        </PrimaryContentPane>
      </BasePane>
    </ContentLayout>
  );
};

export default VendorDetailsPage;
